export enum StructureTypeEnum {
    UOC = 'U.O.C.',
    UOSD = 'U.O.S.D.',
    PROGRAMMI = 'Programmi',
    UOS = 'UnitáOperativaSemplice'
};
